import React from "react";
import { UncontrolledTooltip, Table } from 'reactstrap';

export function TablaCabeceraPractica({ practica }) {

    function formatter(valor) {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: '2', maximumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }
    const porcentaje = Math.round(practica.evaluados * 100 / practica.registrados);
    let i = 0;
    return (
        <Table responsive={true} striped={true}>
            <thead>
                <tr><th colSpan={4} className="text-center">Datos generales</th></tr>
            </thead>
            <tbody>
                <tr key={i++}>
                    <td className="font-weight-bold">Periodo:</td>
                    <td>{practica.anio}</td>
                    <td className="font-weight-bold">Unidad:</td>
                    <td>{practica.unidad}</td>
                </tr>
                {practica.programa != null &&
                    <tr key={i++}>
                        <td className="font-weight-bold">Programa:</td>
                    <td>{practica.programa}</td>
                        <td className="font-weight-bold">Cohorte:</td>
                    <td>{practica.cohorte}</td>
                    </tr>
                }
                <tr key={i++}>
                    <td className="font-weight-bold">Actividad:</td>
                    <td>{practica.codigo === "PRAEM" ? "Tutoría de prácticas empresariales" : "Tutoría de prácticas de servicio comunitario"}</td>
                    <td className="font-weight-bold">% Respuestas:</td>
                    <td>
                        <span id={"tt_" + practica.idparalelo} >{porcentaje}%</span>
                        <UncontrolledTooltip placement="left" target={"tt_" + practica.idparalelo}>
                            {practica.evaluados}/{practica.registrados}
                        </UncontrolledTooltip >
                    </td>
                </tr>
                <tr key={i++}>
                    <td className="font-weight-bold">Tutor:</td>
                    <td>{practica.apellidos} {practica.nombres}</td>
                    <td className="font-weight-bold">Promedio:</td>
                    <td>{formatter(practica.promedio)}</td>
                </tr>
            </tbody>
        </Table>
    );

}